/**
 * Gauntlet Debates - A platform for structured, AI-moderated honorable debates
 * Copyright (c) 2025 Gauntlet Debates. All rights reserved.
 * 
 * This file is part of the Gauntlet Debates platform and is protected by 
 * copyright and other intellectual property laws. Unauthorized reproduction,
 * distribution, or disclosure of this file or its contents is prohibited.
 */

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

/**
 * Creates a properly formatted API URL path
 * @param path The relative API path
 * @returns The full API URL
 */
export const makeApiPath = (path: string) => {
  // If API_URL already includes /api, don't add it again
  if (API_URL.endsWith('/api')) {
    return `${API_URL}${path.startsWith('/') ? path : '/' + path}`;
  }
  
  // Otherwise, include /api in the path
  return `${API_URL}/api${path.startsWith('/') ? path : '/' + path}`;
}; 